import translations from './translations'

translations.add('is', {
    headerMessage: 'Hefur þú þegar greitt með bankaappinu þínu?',
    no: 'Nei',
    yes: 'Já'
})
